import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'black-tenant-not-found',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tenant-not-found.component.html',
  styles: [],
})
export class TenantNotFoundComponent {
  public tenantService = inject(TenantService);

  @Input() subdomain?: string;

  get workspaceIdentifier(): string {
    return (
      this.subdomain ||
      this.tenantService.getTenantSubdomain() ||
      this.tenantService.getTenantSlug()
    );
  }

  goToPlatformHome(): void {
    if (typeof window !== 'undefined') {
      window.location.href = this.tenantService.getDefaultPlatformUrl();
    }
  }
}
